import _ from 'lodash';
import { PropTypes } from 'react';
import React from 'react';
import DropdownMenu from './dropdown-menu';
import Config from '../config';

const FilterBar = ({filterOptions, filter, isLoading, onInputChange, clearFilter, onClickDropdownOption, searchPlaceholder = Config.searchPlaceholder}) => {
	const filterDropdowns = filterOptions.map(fo => {
		let ret = null;
		let opt = _.find(Config.filterTaxonomies, { key: fo.name });
		if(!opt.hidden){
			ret = (<DropdownMenu { ...fo }
				key={ fo.name }
				activeOptions={ filter[fo.name] ? filter[fo.name] : [] }
				onClickOption={ onClickDropdownOption }
			/>);
		}

		return ret;
	});

	let classList = ['filter-bar'];
	if(isLoading){
		classList.push('loading');
	}

	return (
		<div className={ classList.join(' ') }>
			<div className="container">
				<div className="filter-dropdowns">
					<div className="title">Filter By</div>
					{ filterDropdowns }
				</div>
				<div className="search input-wrapper">
					<label htmlFor="search">
						<span className="screen-reader-text">search</span>
					</label>
					<input placeholder={ searchPlaceholder }
									onChange={ onInputChange } id="search" />
					<button className="reset-search"><i className="icon icon-close" data-grunticon-embed /></button>
					<i className="icon icon-search" data-grunticon-embed />
				</div>
			</div>
		</div>
	)
}

FilterBar.propTypes = {
	filterOptions: PropTypes.array,
	filter: PropTypes.object,
	isLoading: PropTypes.bool,
	onInputChange: PropTypes.func,
	clearFilter: PropTypes.func,
	onClickDropdownOption: PropTypes.func,
	searchPlaceholder: PropTypes.string
}

export default FilterBar;
